var render = function render(){var _vm=this,_c=_vm._self._c;return _c('hic-list-page',{attrs:{"title":"护理"}})
}
var staticRenderFns = []

export { render, staticRenderFns }